<template>
  <v-card
    :class="{'px-3 py-3 mx-2 my-2' : true}"
    :color="backgroundColor"
    dark
    min-width="450"
    max-width="450"
    @click="goTo"
  >
    <v-card-title style="height: 100%">
      <v-row>
        <v-col cols="12">
          <v-container bg fill-height>
            <v-layout>
              <v-icon x-large>
                {{icon}}
              </v-icon>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-container>
            <v-layout class="px-1">
              <h3>
                {{text}}
              </h3>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>

    </v-card-title>
  </v-card>
</template>

<script>

    export default  {
        props: {
            text: {
                default: 'Home'
            },
            link: {
                default: '/'
            },
            backgroundColor: {
                default: 'gray'
            },
            hasRoundCorners: {
                default: false,
            },
            hasBoxShadow: {
                default: true
            },
            icon: {
                default: 'mdi-twitter'
            }

        },
        name: "Cards",
        // data() {
        //     return {
        //         bgcolor: this.props.color,
        //     }
        // },
        methods: {
            goTo() {
                this.$router.push(this.link)
            }
        }
    }
</script>

<style scoped>
  .round-corners {
    border-radius: 25px 25px 25px 25px !important;

  }
</style>
